import { ModalComponent } from '../../../components/ModalComponent/ModalComponent';
import { LoadingId, User } from '../../../types';
import { useTheme } from '@mui/material';
import { Typography } from '../../../components/Typography/Typography';
import { useLoadingBar } from '../../../hooks/useLoadingBar';
import { useToastMessage } from '../../../hooks/useToastMessage';
import { extractErrorMessage } from '../../../utils/errorNotifier';
import { useResetUserTimesheets } from '../../../queries/hooks/useResetUserTimesheets';

type Props = {
  resetUserOpen: boolean;
  toggleResetUser: () => void;
  user: User;
};

export function ResetUserModal({ user, resetUserOpen, toggleResetUser }: Props) {
  const { colors } = useTheme();
  const { pushSuccessToast, pushErrorToast } = useToastMessage();
  const { startLoading, stopLoading } = useLoadingBar();

  const userName = user?.name;
  const { mutate: onResetUser, isLoading: resetInProgress } = useResetUserTimesheets();

  const handleResetUser = async () => {
    startLoading(LoadingId.resetUser);
    onResetUser(user.id, {
      onSuccess: () => {
        pushSuccessToast({
          title: `${userName}'s Timesheets are Reseted`,
          message: `${userName}'s timesheets has been successfully reseted.`,
        });
        toggleResetUser();
      },
      onError: (error: unknown) => {
        pushErrorToast({ message: extractErrorMessage(error) });
      },
      onSettled: () => {
        stopLoading(LoadingId.resetUser);
      },
    });
  };

  return (
    <ModalComponent
      isOpen={resetUserOpen}
      onClose={toggleResetUser}
      actionButtonsProps={{
        isSubmitDisabled: resetInProgress,
        onSubmit: handleResetUser,
        onCancel: toggleResetUser,
        submitText: 'Reset',
        submitBtnStyle: {
          background: resetInProgress ? undefined : colors.iconStatus.active,
        },
      }}
      title={`Reset ${userName}'s Timesheets`}
      top='80px'
    >
      <Typography variant='body' color={colors.text.main}>
        This action will reset and clear any existing timesheets this user has, are you sure you
        want to reset {user.name}&apos;s timesheets?
      </Typography>
    </ModalComponent>
  );
}
